import { call, put } from 'redux-saga/effects';
import { getHistory } from 'app/history';
import { auth } from 'mz-sdk';
import posthog from 'posthog-js';
import { showNotification } from 'app/actions/notifications';
import { NOTIFICATION_ERROR } from 'app/constants';
import { removeCookie } from 'app/utils/cookie';

export default function* doLogout() {
  try {
    yield call(auth.logout);

    // Delete user data for third-party libs.
    window.mozioUser = null;
    posthog.reset();

    // Drop the shared TA locale preference so a later cold load resolves fresh.
    removeCookie('ta-locale');

    // Redirect to the home page on logout
    const history = yield call(getHistory);
    yield call(history.push, '/');
  } catch (error) {
    yield put(showNotification({
      type: NOTIFICATION_ERROR,
      message: error.message
    }))
  }
}
